import React from "react";
import { Bell, Mail, MessageCircle } from "lucide-react";

export const CHANNELS = [
  ["app", "داخل التطبيق", Bell],
  ["email", "البريد الإلكتروني", Mail],
  ["whatsapp", "واتساب", MessageCircle],
];
export const DEFAULT_CHANNELS = ["app", "email"];

export const ChannelPicker = ({ value, onChange, testid = "admin-channels" }) => {
  const toggle = (c) => onChange(value.includes(c) ? value.filter((x) => x !== c) : [...value, c]);
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid} role="group" aria-label="قنوات الإرسال">
      {CHANNELS.map(([c, label, Icon]) => {
        const on = value.includes(c);
        return (
          <button key={c} type="button" onClick={() => toggle(c)} aria-pressed={on} data-testid={`${testid}-${c}`}
            className={`h-9 px-2.5 rounded-lg text-xs font-bold border flex items-center gap-1 transition-colors ${on ? "bg-[#09637E] border-[#09637E] text-white" : "bg-white border-[#7AB2B2] text-[#09637E]"}`}>
            <span className={`w-3.5 h-3.5 rounded-sm border flex items-center justify-center text-[10px] leading-none ${on ? "bg-white text-[#09637E] border-white" : "border-[#7AB2B2]"}`}>{on ? "✓" : ""}</span>
            <Icon size={13} /> {label}
          </button>
        );
      })}
      {value.length === 0 && <span className="text-[11px] text-rose-600 font-bold" data-testid={`${testid}-error`}>اختر قناة واحدة على الأقل</span>}
    </div>
  );
};

export const resultToast = (toast, data) => {
  if (data.status === "success") toast.success(data.message);
  else if (data.status === "partial") toast.warning(data.message);
  else if (data.status === "failed") toast.error(data.message);
  else if (data.email === "failed") toast.warning(data.message);
  else toast.success(data.message);
};
